// src/components/IntroOverlay/IntroOverlay.js
import React, { useEffect, useRef, useState } from "react";
import "./IntroOverlay.css";

export default function IntroOverlay({
  logoSrc,
  onDone,
  durationMs = 1600,
}) {
  const [phase, setPhase] = useState("enter"); // enter -> exit
  const [visible, setVisible] = useState(true);

  const doneRef = useRef(false);
  const timersRef = useRef([]);

  const safeDone = () => {
    if (doneRef.current) return;
    doneRef.current = true;
    onDone?.();
  };

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const t1 = setTimeout(() => setPhase("exit"), durationMs);

    const t2 = setTimeout(() => {
      setVisible(false);
      document.body.style.overflow = prevOverflow;
      safeDone();
    }, durationMs + 520);

    timersRef.current.push(t1, t2);

    return () => {
      timersRef.current.forEach((t) => clearTimeout(t));
      timersRef.current = [];
      document.body.style.overflow = prevOverflow;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [durationMs]);

  const skip = () => {
    timersRef.current.forEach((t) => clearTimeout(t));
    timersRef.current = [];

    setPhase("exit");
    setTimeout(() => {
      setVisible(false);
      safeDone();
    }, 260);
  };

  if (!visible) return null;

  return (
    <div className={`intro ${phase}`} aria-hidden="true">
      <div className="intro__frost" />
      <div className="intro__noise" />

      <div className="intro__logoStage">
        {logoSrc ? <img className="intro__logoMark" src={logoSrc} alt="" /> : null}
      </div>

      <button className="intro__skip" onClick={skip}>
        Skip
      </button>
    </div>
  );
}
